import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_email", data.email);
      localStorage.setItem("admin_role", data.role);
      toast.success(`Accesso effettuato come ${data.role === "admin" ? "Amministratore" : "Operatore"}`);
      navigate("/admin");
    } catch {
      toast.error("Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6 bg-grid">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex flex-col items-center gap-3 mb-3">
            <img src="/logo.png" alt="Officina Franco" className="h-24 w-auto" />
            <div className="font-serif-display text-2xl text-slate-900">
              Officina <span className="text-red-600">Franco</span>
            </div>
          </div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-slate-500">Area Riservata</div>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-white border border-slate-200 p-8 lg:p-10 space-y-6 shadow-sm"
        >
          <div className="flex items-center gap-3 border-b border-slate-200 pb-5">
            <Lock className="w-4 h-4 text-red-600" />
            <div className="text-xs tracking-[0.2em] uppercase text-slate-700">Accesso Admin</div>
          </div>
          <div className="space-y-2">
            <Label className="text-[10px] tracking-[0.25em] uppercase text-slate-500">Email</Label>
            <Input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none border-slate-300 focus-visible:ring-blue-900 focus-visible:ring-1 focus-visible:ring-offset-0"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-[10px] tracking-[0.25em] uppercase text-slate-500">Password</Label>
            <Input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none border-slate-300 focus-visible:ring-blue-900 focus-visible:ring-1 focus-visible:ring-offset-0"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-red-600 hover:bg-red-700 rounded-none h-12 text-xs tracking-[0.25em] uppercase"
          >
            {loading ? "Accesso..." : "Entra"}
          </Button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-xs tracking-[0.25em] uppercase text-slate-500 hover:text-blue-900">
            ← Torna al sito
          </a>
        </div>
      </div>
    </div>
  );
}
